import { c as _c } from "react/compiler-runtime";
import { IcoSparkles16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';

// Default post-answer follow-ups. Static for now — the real value comes from
// agent-generated follow-ups (e.g. a `suggestions` field on `turn_complete`).
// When that lands, pass them in via props and drop this constant; the rest of
// the component is already data-driven.
const PLACEHOLDER_SUGGESTIONS = ['Summarize the key takeaways', 'What should I look into next?', 'Any risks or anomalies I should know about?'];
type SuggestionChipsProps = {
  /** Defaults to the static placeholder set above. */
  suggestions?: string[];
  onSelect: (prompt: string) => void;
  /**
   * `stack` (default) left-aligns a vertical list — used under a completed turn.
   * `wrap` centers wrapping chips — used on the zero-state above the composer.
   */
  layout?: 'stack' | 'wrap';
};
const FollowUpSuggestions = t0 => {
  const $ = _c(10);
  const {
    suggestions: t1,
    onSelect,
    layout: t2
  } = t0;
  const suggestions = t1 === undefined ? PLACEHOLDER_SUGGESTIONS : t1;
  const layout = t2 === undefined ? "stack" : t2;
  if (suggestions.length === 0) {
    return null;
  }
  const t3 = layout === "wrap" ? "flex-wrap justify-center" : "flex-col items-start pt-1";
  let t4;
  if ($[0] !== t3) {
    t4 = cx("flex gap-2", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== onSelect || $[3] !== suggestions) {
    let t6;
    if ($[5] !== onSelect) {
      t6 = suggestion => <button key={suggestion} type="button" onClick={() => onSelect(suggestion)} className="flex items-center gap-1.5 min-h-8 max-md:max-w-full py-1.5 md:h-8 md:py-0 px-3 rounded-full border border-tertiary text-label-3 text-secondary hover:bg-hover-control hover:text-primary transition-colors cursor-pointer text-left"><IcoSparkles16 className="shrink-0 text-tertiary" />{suggestion}</button>;
      $[5] = onSelect;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    t5 = suggestions.map(t6);
    $[2] = onSelect;
    $[3] = suggestions;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default FollowUpSuggestions;